// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"62":"71e6f0a19052c5fcdb2d","895":"5fced293e7c4c5f86d23"}[chunkId] + ".js";
};